<template>
    <section
        class="mx-auto flex min-h-[60vh] max-w-2xl items-center px-6 py-16"
    >
        <div
            class="w-full border-l-4 border-danger-600 bg-danger-50 p-8 shadow-sm"
        >
            <div class="mb-4 flex items-center gap-3 text-danger-700">
                <i class="pi pi-exclamation-triangle text-3xl" />
                <h1 class="text-3xl font-bold">
                    {{
                        t(
                            processingTimedOut
                                ? 'checkout.paymentProcessingStuckTitle'
                                : 'checkout.paymentRecoveryErrorTitle'
                        )
                    }}
                </h1>
            </div>
            <p class="mb-6 text-lg text-gray-700">
                {{
                    t(
                        processingTimedOut
                            ? 'checkout.paymentProcessingStuckMessage'
                            : 'checkout.paymentRecoveryErrorMessage'
                    )
                }}
            </p>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(
    defineProps<{
        processingTimedOut?: boolean
    }>(),
    {
        processingTimedOut: false
    }
)

// Recovery remains informational because neither elapsed time nor an error proves payment failed.
const { t } = useI18n({ useScope: 'global' })
</script>
